import { Card, Grid, Typography } from "@mui/material"
import { Link, useNavigate } from "react-router-dom"

export const SingleFeedback = ({ item }) => {
	const navigate = useNavigate()

	const handleClick = () => {
		navigate(`/admin/palaute/${item.feedbackid}`)
	}

	return (
		<Grid item xs={1}>
			<Link to={`/admin/palaute/${item.feedbackid}`}>
				<Card elevation={3} sx={{ cursor: "pointer" }} onClick={handleClick}>
					<Typography variant="h6">Lähettäjä: {item.name}</Typography>
				</Card>
			</Link>
		</Grid>
	)
}
